var map = {
	"./block31.png": 5448,
	"./block32.png": 5107,
	"./block33.png": 979,
	"./block34.png": 4033,
	"./block35.png": 9058,
	"./block36.png": 1628,
	"./block37.png": 3197,
	"./block38.png": 3342,
	"./block3Background.png": 1238
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1563;